import { AssumptionsExclusionsDataImport } from "./assumptions-exclusions-data-import";

import React, { useState } from "react";
import { LIBRARY_EXCLUSIONS_QUERY, MATTER_EXCLUSIONS_QUERY } from "../../../graphql/query";
import { useMutation, useQuery } from "@apollo/client";
import { UPDATE_LIBRARY_EXCLUSIONS } from "../../../graphql/mutation";
import {
  CreateLibraryExclusion,
  CreateLibraryExclusionVariables,
} from "@graphql-types/CreateLibraryExclusion";
import {
  FindLibraryExclusions,
  FindLibraryExclusionsVariables,
} from "@graphql-types/FindLibraryExclusions";
import { VpdDataImportType } from "../../../graphql/__generated_types__/globalTypes";
import { CREATE_LIBRARY_EXCLUSION } from "../../../graphql/mutation/exclusion/create-library-exclusion";
import {
  LibraryAssumptionWhereInput,
  UpdateLibraryExclusionsMutation,
  UpdateLibraryExclusionsMutationVariables,
} from "~/gql/graphql";

export const ExclusionsDataImportWrapper = () => {
  const [orgUnitFilter, setOrgUnitFilter] = useState<number | null>(null);

  const filter: LibraryAssumptionWhereInput =
    orgUnitFilter === 0
      ? { organisationalUnits: { none: {} } }
      : orgUnitFilter !== null
      ? {
          organisationalUnits: { some: { id: { equals: orgUnitFilter } } },
        }
      : {};

  const { loading: queryLoading, data } = useQuery(LIBRARY_EXCLUSIONS_QUERY, {
    variables: {
      filter,
    },
  });

  const { refetch: refetchMatterExclusions } = useQuery(MATTER_EXCLUSIONS_QUERY);

  const [updateLibraryExclusions, { loading: updateLoading }] = useMutation<
    UpdateLibraryExclusionsMutation,
    UpdateLibraryExclusionsMutationVariables
  >(UPDATE_LIBRARY_EXCLUSIONS, { refetchQueries: [LIBRARY_EXCLUSIONS_QUERY] });

  const [createLibraryAssumption] = useMutation<
    CreateLibraryExclusion,
    CreateLibraryExclusionVariables
  >(CREATE_LIBRARY_EXCLUSION, {
    update(cache, { data }) {
      if (!data?.createLibraryExclusion) return;
      const existingData = cache.readQuery<FindLibraryExclusions, FindLibraryExclusionsVariables>({
        query: LIBRARY_EXCLUSIONS_QUERY,
        variables: {
          filter: {},
        },
      });
      cache.writeQuery<FindLibraryExclusions, FindLibraryExclusionsVariables>({
        query: LIBRARY_EXCLUSIONS_QUERY,
        variables: {
          filter: {},
        },
        data: {
          libraryExclusions: [
            ...(existingData?.libraryExclusions || []),
            data.createLibraryExclusion,
          ],
        },
      });
    },
  });

  return (
    <AssumptionsExclusionsDataImport
      type={VpdDataImportType.LibraryExclusion}
      items={data?.libraryExclusions || []}
      updateLibraryItem={({ variables, onCompleted }) => {
        updateLibraryExclusions({
          variables,
          onCompleted: (data) => {
            if (onCompleted) {
              onCompleted();
            }
            const updatedMatterIds = data?.updateLibraryExclusions.matterIds || [];
            updatedMatterIds.forEach((matterId) => {
              refetchMatterExclusions({ input: matterId });
            });
          },
        });
      }}
      createLibraryItem={({ variables, onCompleted }) => {
        createLibraryAssumption({ variables, onCompleted });
      }}
      updateLoading={updateLoading}
      queryLoading={queryLoading}
      handleOrgUnitFilterChange={(val) => setOrgUnitFilter(val)}
    />
  );
};
